import type { RL, RP } from '@/api';
import type { TenantResource } from './model';
import { RParam } from '@/api';
import LzdAjax from '@/utils/lzd-ajax';

/** 基础地址 */
const BASE_URL = '/bsl/tenant/resource';

/**
 * 分页查询资料
 */
export async function pageTenantResources(params: RP) {
  return LzdAjax.post<RL<TenantResource>>(
    `${BASE_URL}/query/page`,
    params
  ).then((v) => v.data);
}

/**
 * 通用查询资料
 */
export async function listTenantResources(params: RP) {
  return LzdAjax.post<TenantResource[]>(`${BASE_URL}/query/list`, params).then(
    (v) => v.data
  );
}

/**
 * 批量添加资料
 */
export async function insertTenantResources(data: Partial<TenantResource>[]) {
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/insert`, {
    ...data,
    seq: void 0
  });
}

/**
 * 修改资料
 */
export async function updateTenantResource(data: Partial<TenantResource>) {
  if (!data.seq) {
    return Promise.reject(new Error('SEQ不能为空'));
  }
  const rp: RP = {
    update: RParam.buildEdit(data, (k: string) => k != 'id'),
    where: [RParam.eq('id', data.id), RParam.eq('seq', data.seq)]
  };
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/update`, rp);
}

/**
 * 批量修改资料
 */
export async function updateTenantResources(params: RP) {
  if (!params.update?.length) {
    return Promise.reject(new Error('没有修改的数据'));
  }
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/update`, params);
}

/**
 * 修改资料下载次数（通用）
 */
export async function updateTenantResourceDownloads(
  data: Partial<TenantResource>
) {
  if (!data.seq) {
    return Promise.reject(new Error('SEQ不能为空'));
  }
  const rp: RP = {
    update: RParam.buildEdit(data, (k: string) => k != 'id'),
    where: [RParam.eq('id', data.id), RParam.eq('seq', data.seq)]
  };
  return LzdAjax.post<unknown>(`${BASE_URL}/update/downloads`, rp);
}

/**
 * 批量删除资料
 */
export async function removeTenantResources(pks: number[]) {
  return LzdAjax.post<unknown>(`${BASE_URL}/manager/delete`, {
    pks,
    where: []
  });
}
